<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="$t('queues.add')"
    @change="loading ? null : $emit('input', $event)"
  >
    <error-alert :error="error" />
    <validation-observer ref="form">
      <slide-y-up-transition>
        <b-row>
          <b-col
            sm="12"
            md="6"
          >
            <ok-text-input
              v-model.trim="form.name"
              :from-component="true"
              :label="$t('fields.name')"
              :is-required="true"
            />

          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group
              style="margin-top: 7px"
              :label="$t('fields.phone')"
              label-class="required"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('queues.num-of-people')"
                :rules="'required'"
              >
                <ok-phone-number-input v-model="form.phone" />
                <small class="text-danger">{{ errors[0] }}</small>

              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <ok-text-input
              v-model.trim="form.count"
              :from-component="true"
              :label="$t('queues.num-of-people')"
              :is-required="true"
              rules="numeric"
            >
              <b-form-spinbutton
                v-model.trim="form.count"
                :min="1"
              />
            </ok-text-input>
          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group
              :label="$t('queues.choose-table', [tableLabel(1)])"
            >
              <v-select
                v-model="table"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                input-id="id"
                :options="tables"
                :multiple="false"
                :plcaeholder="$t('queues.choose-table', [tableLabel(1)])"
                :clearable="false"
                label="name"
                class="filter-select"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
          />
          <b-col
            md="12"
          >
            <b-form-group
              :label="$t('general.note')"
            >
              <b-form-textarea v-model="form.note" />
            </b-form-group>
          </b-col>
        </b-row>
      </slide-y-up-transition>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="dark"
          :disabled="loading"
          @click="submit()"
        >
          <span :class="{'pr-1': loading}">{{ $t('forms.save') }}</span>
          <b-spinner
            v-if="loading"
            small
          />
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BButton, BSpinner, BFormTextarea, BFormSpinbutton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import OkModal from '@/@okmenu/components/modals/OkModal'
import ErrorAlert from '@/@okmenu/components/alerts/ErrorAlert'
import OkPhoneNumberInput from '@/@okmenu/components/inputs/OkPhoneNumberInput'
import OkTextInput from '@/@okmenu/components/inputs/OkTextInput'
import QueueAPI from '@/API/QueueAPI'
import BusinessTypeMixin from '@/mixins/business-type-mixin'

export default {
  name: 'AddQueuesModal',
  components: {
    OkTextInput,
    ErrorAlert,
    OkPhoneNumberInput,
    ValidationObserver,
    ValidationProvider,
    OkModal,
    BButton,
    BSpinner,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BFormTextarea,
    BFormSpinbutton,
  },
  mixins: [BusinessTypeMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      table: '',
      tables: [],
      now: this.$moment().toISOString(),
      form: {},
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/user']
    },
  },
  watch: {
    value() {
      this.error = null
    },
  },
  mounted() {
    this.init()
    this.$nextTick(() => { this.tables = this.$store.getters['queues/tables'] })
  },
  methods: {
    init() {
      this.form = {
        name: '',
        phone: '',
        note: '',
        count: 1,
      }
      this.table = {}
    },
    async submit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        throw new Error(this.$tc('errors.field-invalid', 2))
      }
      this.loading = true
      const form = { ...this.form, table_id: this.table?.id ?? null }
      await QueueAPI.addReservation(form)
        .then(response => {
          if (response?.response === 201) {
            this.init()
            this.$emit('updated')
            this.$notifySuccess(response.message)
          } else {
            this.$notifyError(response.message)
          }
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => { this.loading = false })
    },
  },
}
</script>
